
import { parseISO } from "date-fns";
/**
 * Utilidades para formateo de datos
 */

/**
 * Formatea un número como moneda
 * @param value - Valor a formatear
 * @param currency - Código de moneda (por defecto USD)
 * @returns Cadena formateada como moneda
 */
export const formatCurrency = (value: number, currency: string = 'USD'): string => {
    return new Intl.NumberFormat(currency === 'COP' ? 'es-CO' : 'es-ES', {
        style: 'currency',
        currency,
        minimumFractionDigits: currency === 'COP' ? 0 : 2,
        maximumFractionDigits: currency === 'COP' ? 0 : 2,
    }).format(value);
};

/**
 * Formatea una fecha en formato legible
 * @param dateString - Cadena de fecha ISO
 * @returns Fecha formateada
 */

export const formatDate = (dateString: string | undefined) => {
  if (!dateString) return '';
 
  try {
    const date = parseISO(dateString); 
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    const hh = String(date.getUTCHours()).padStart(2, '0');
    const min = String(date.getUTCMinutes()).padStart(2, '0');

    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  } catch (error) {
    return '';
  }
};

export const formatDateDayMonthYear = (dateString: string) => {
    // Extraer solo la parte de la fecha (YYYY-MM-DD) para evitar problemas de zona horaria
    const dateOnly = dateString.split('T')[0];
    const [year, month, day] = dateOnly.split('-');

    // Crear fecha usando los componentes individuales para evitar conversión de zona horaria
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

    return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};